export const LOCALES = {
  ENGLISH: 'en-us',
  GERMAN: 'de-de',
  FRENCH: 'fr-ca',
  IGBO: 'ig-ni',
  YORUBA: 'yo-ni',
  HAUSA: 'ha-ni',
}